import { AsyncThunk, createAsyncThunk, AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import { RootState } from '~/App/store';
import { dispatchWrapper, generateCsrfToken } from '~/api';
import MyAxios from '~/api/axios';
import GmoAskError from '~/errors/GmoAskError';

const request = async ({
  method,
  url,
  params = undefined,
}: {
  method: string;
  url: string;
  params?: any;
}) => {
  try {
    const Axios = new MyAxios(window.location);
    const res = await (Axios as any)[method](url, params);
    return res.data;
  } catch (error: any) {
    throw new GmoAskError(
      'Axios error',
      error?.message,
      error?.response?.data,
      error?.response?.status
    );
  }
};

/* istanbul ignore next default引数などがカバレッジ通らないため */
export const get = async ({ url, params }: { url: string; params?: any }) =>
  request({
    method: 'get',
    url,
    params,
  });

/* istanbul ignore next default引数などがカバレッジ通らないため */
export const post = async ({ url, params }: { url: string; params?: any }) =>
  request({
    method: 'post',
    url,
    params,
  });

/* istanbul ignore next default引数などがカバレッジ通らないため */
export const put = async ({ url, params }: { url: string; params?: any }) =>
  request({
    method: 'put',
    url,
    params,
  });

/* delは今のところ利用されていないため */
// export const del = async ({ url, params = undefined }: { url: string; params?: any }) =>
//   request({
//     method: 'del',
//     url,
//     params,
//   });

type GmoAskErrorObject = {
  name?: string;
  message?: string;
  data?: object;
  status?: number;
};

/**
 * rejectする時に、payloadにnon-serializable valuesがセットされるのを防ぐため、
 * エラーを一定のフォーマットのオブジェクトに変換する。
 */
export const formatError = (error: any): GmoAskErrorObject => ({
  name: error?.name,
  message: error?.message,
  data: error?.data,
  status: error?.status,
});

type AsyncThunkConfig = {
  state: any;
};

/**
 * createAsyncThunkのラッパー。
 * 対象のthunkを作成する前に必ずcsrfTokenが発行済みかを確認する。
 * 発行済みでなければ、発行後に対象のthunkをコールする。
 */
export const createGmoAskAsyncThunk = <Returned, ThunkArg = any>(
  type: string,
  thunk: AsyncThunkPayloadCreator<Returned, ThunkArg>
): AsyncThunk<Returned, ThunkArg, AsyncThunkConfig> =>
  createAsyncThunk<Returned, ThunkArg, AsyncThunkConfig>(type, async (arg, thunkAPI) => {
    try {
      /**
       * do some stuff here that happens on every action
       */
      // generate csrf token if not yet
      const { isGeneratedCsrfToken } = thunkAPI.getState().appCommon as RootState['appCommon'];
      if (!isGeneratedCsrfToken) {
        await dispatchWrapper(() => thunkAPI.dispatch(generateCsrfToken()));
      }
      return (await thunk(arg, thunkAPI)) as Returned;
    } catch (error) {
      console.error('something happened in async thunk action.\nerror: ', error);
      // formatしてrejectする。
      return thunkAPI.rejectWithValue(formatError(error));
    }
  });
